let mapper_options = {
  endpoint: 'communication_automations',
  recordClass: require('./record'),
  relations: {
    belongsTo: {
      communication: {
        foreignKey: 'communication_id',
        localField: 'communication'
      },
      share_setting: {
        foreignKey: 'share_setting_id',
        localField: 'share_setting'
      }
    }
  }
}

module.exports = (store) => {
  store.defineMapper('communication_automation', mapper_options)
}
